import * as React from 'react';
import { Select } from 'antd';
import CommonFormItem from '../CommonFormItem';
import { getData } from '@util';
import { SUCCESSCODE } from '@enum';
import PropTypes from 'prop-types';

const fetchControlTime = 300; // 节流时间间隔
const defaultStyle = { width: '100%' };

class NativeSelect extends React.Component {
  static propTypes = {
    allowClear: PropTypes.bool,
    dropdownMatchSelectWidth: PropTypes.bool,
    filterOption: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  };
  static defaultProps = {
    allowClear: true,
    dropdownMatchSelectWidth: false,
    filterOption: true,
  };
  constructor(props) {
    super(props);
    this.state = {
      children: this.initChildren(props),
    };
    this.handleSearch = this.handleSearch().bind(this);
  }
  UNSAFE_componentWillMount() {
    if (this.props.listConfig) {
      this.handleFetchList(this.props.listConfig);
    }
  }
  UNSAFE_componentWillReceiveProps(props) {
    if (this.props.listConfig !== props.listConfig) {
      props.listConfig && this.handleFetchList(props.listConfig);
    }
    if (this.props.list !== props.list) {
      this.setState({ children: this.initChildren(props) });
    }
    if (this.props.resetList !== props.resetList) {
      this.setState({ children: [] });
    }
  }
  componentWillUnmount() {
    this.unMount = true;
  }
  handleFetchList(listConfig) {
    getData(listConfig).then(data => {
      if (this.unMount || !data) {
        return;
      }
      if (data.code === SUCCESSCODE) {
        let arr = [];
        const sign =
            (data.hasOwnProperty('result') && 'result') ||
            (data.hasOwnProperty('data') && 'data') ||
            'page',
          needData = data[sign];
        arr = Array.isArray(needData)
          ? needData
          : needData.result
          ? needData.result
          : needData.dataList;
        this.setState({ children: this.renderChildren(arr, this.props) });
      }
    });
  }
  handleSearch() {
    let preTime = 0,
      lastFetch;
    return value => {
      const { onSearch } = this.props;

      if (!onSearch) {
        return;
      }
      const now = +new Date();

      if (now - preTime < fetchControlTime) {
        clearTimeout(lastFetch);
      }
      preTime = now;
      lastFetch = setTimeout(() => {
        !this.unMount && onSearch(value);
      }, fetchControlTime);
    };
  }
  initChildren(props) {
    const { list, children } = props;
    if (list) {
      return this.renderChildren(list, props);
    } else {
      return children;
    }
  }
  renderChildren(list, props) {
    const {
      listRenderGetLabel = this.getLabel,
      listRenderGetValue = this.getValue,
      beforeListRender,
    } = props;
    const { listRenderGetShow = listRenderGetLabel } = props;
    if (beforeListRender) {
      list = beforeListRender(list);
    }
    return list.map(item => {
      const value = listRenderGetValue(item);
      const key = value;
      const show = listRenderGetShow(item);
      const label = listRenderGetLabel(item);
      return (
        <Select.Option key={key} value={value} show={show}>
          {label}
        </Select.Option>
      );
    });
  }
  getValue(item) {
    return item.code;
  }
  getLabel(item) {
    return item.value;
  }
  loadStyle(style) {
    return Object.assign({}, defaultStyle, style);
  }
  focus() {
    this.select.focus();
  }
  blur() {
    this.select.blur();
  }
  render() {
    const { style, ...props } = this.props;
    const { children } = this.state;
    const selectProps = {
      ...props,
      style: this.loadStyle(style),
      onSearch: this.handleSearch,
      optionLabelProp: 'show',
      children,
    };
    return <Select {...selectProps} ref={node => (this.select = node)} />;
  }
}

export default class CommonSelect extends React.Component {
  static Option = Select.Option;
  static Select = NativeSelect;
  focus() {
    this.select.focus();
  }
  blur() {
    this.select.blur();
  }
  render() {
    const {
      formItemPrefixCls,
      formItemClass,
      formItemId,
      label,
      labelCol,
      wrapperCol,
      help,
      extra,
      validateStatus,
      hasFeedback,
      required,
      style,
      colon,
      valuePropName,
      initialValue,
      trigger,
      getValueFromEvent,
      validateTrigger,
      rules,
      exclusive,
      normalize,
      validateFirst,
      decorator,
      getFieldDecorator,

      selectStyle,
      ...props
    } = this.props;
    const formItemSettings = {
      prefixCls: formItemPrefixCls,
      className: formItemClass,
      id: formItemId,
      label,
      labelCol,
      wrapperCol,
      help,
      extra,
      validateStatus,
      hasFeedback,
      required,
      style,
      colon,
      valuePropName,
      initialValue,
      trigger,
      getValueFromEvent,
      validateTrigger,
      rules,
      exclusive,
      normalize,
      validateFirst,
      decorator,
      getFieldDecorator,
    };
    const selectSettings = {
      style: selectStyle,
      ...props,
    };
    return (
      <CommonFormItem {...formItemSettings}>
        <NativeSelect {...selectSettings} ref={node => (this.select = node)} />
      </CommonFormItem>
    );
  }
}
